import Modal from '@amzn/meridian/modal';
import Row from '@amzn/meridian/row';
import Button from '@amzn/meridian/button';
import Text from '@amzn/meridian/text';
import Column from '@amzn/meridian/column';
import Heading from '@amzn/meridian/heading';
import Divider from '@amzn/meridian/divider';

interface HelpModalProps {
    open: boolean;
    onClose: () => void;
}

const dataEngineeringTeamTicketLink =
    'https://sim.amazon.com/issues/create?template=22689341-290a-4c97-9d04-090d108ab821';

const HelpModal = ({ open, onClose }: HelpModalProps) => {
    return (
        <Modal
            open={open}
            width={700}
            onClose={onClose}
            scrollContainer='viewport'
            closeLabel='Close'
            aria-describedby='modal-button'
        >
            <Column spacingInset='400 500' spacing='300'>
                <div className="pf-welcomeModal">How can I help you?</div>
                <Text type='b200'>Modes allow you to use GoBot in different ways..</Text>
            </Column>
            <Divider />
            {/*<Row widths={['fill', 'fill']}>*/}
            {/*    <Column spacingInset='300 500' spacing='300'>*/}
            {/*        <div className="pf-welcomeModal">Package Hub</div>*/}
            {/*        <Text type='b200'>Our AI-powered system provides real-time package flow analytics. This intelligent platform integrates data streams from multiple sources, offering predictive insights and automated decision support for volume planning and execution. The system features neural network-based anomaly detection and machine learning algorithms that continuously improve accuracy through operational feedback. Example: What is the SWA volume for ABQ5 in night shift?</Text>*/}
            {/*    </Column>*/}

            {/*</Row>*/}

            <Row widths={['fill', 'fill']}>
                <Column spacingInset='300 500' spacing='300'>
                    <div className="pf-welcomeModal">
                        Site Intelligence
                    </div>
                    <Text type='b200'>A dynamic, self-updating repository of site information. Natural Language Processing (NLP) capabilities enable intuitive search and retrieval of site-specific data, while machine learning models help predict future capacity requirements and optimize site utilization. Example: When was OAK5 site launched?</Text>
                </Column>
            </Row>
            <Row widths={['fill', 'fill']}>
                <Column spacingInset='300 500' spacing='300'>
                    <div className="pf-welcomeModal">
                        General
                    </div>
                    <Text type='b200'>AI-powered solution give the functionality to search 400+ wiki pages across the NASC org to on-board faster in operations domain. Example: What is RVA? What is GoldenEye</Text>
                </Column>
            </Row>

        </Modal>
    );
};

export default HelpModal;
